import React from "react";
import { Grid, TextField, Checkbox, FormControlLabel } from "@mui/material";
import SectionCard from "./SectionCard";

const Step3FactoryInfo = ({
  formData,
  setFormData,
  onFieldChange,
  setFieldValue,
   errors,
  touched,
}) => {
  const fieldError = (name) => Boolean(touched?.[name] && errors?.[name]);
  const fieldHelper = (name) => (touched?.[name] && errors?.[name]) || "";
  const handleSameAsCompanyChange = (event) => {
    const checked = event.target.checked;
    setFieldValue?.("factoryAddressSameAsCompany", checked);

    // if (!checked) return;

    // Copy company address fields into factory address fields
    const mapping = [
      ["companyStreetDoorNo", "factoryStreetDoorNo"],
      ["companyAddressLine1", "factoryAddressLine1"],
      ["companyAddressLine2", "factoryAddressLine2"],
      ["companyAddressLine3", "factoryAddressLine3"],
      ["companyAddressLine4", "factoryAddressLine4"],
      ["companyAddressLine5", "factoryAddressLine5"],
      ["companyPostalCode", "factoryPostalCode"],
      ["companyCity", "factoryCity"],
      ["companyStateRegion", "factoryStateRegion"],
      ["companyCountry", "factoryCountry"],
    ];

    // mapping.forEach(([src, dest]) => {
    //   setFieldValue?.(dest, formData[src] || "");
    // });
     if (checked) {
    mapping.forEach(([src, dest]) => {
      setFieldValue?.(dest, formData[src] || "");
    });
  } else {
    mapping.forEach(([, dest]) => {
      setFieldValue?.(dest, "");
    });
  }
  };

  return (
    <Grid container spacing={2}>
      <SectionCard title="FACTORY ADDRESS*">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(formData.factoryAddressSameAsCompany)}
                  onChange={handleSameAsCompanyChange}
                  name="factoryAddressSameAsCompany"
                />
              }
              label="Factory Address (Same as Company Address)"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              size="small"
              label="Street / Door No"
              name="factoryStreetDoorNo"
              value={formData.factoryStreetDoorNo || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
              error={
          !formData.factoryAddressSameAsCompany &&
          fieldError("factoryStreetDoorNo")
        }
        helperText={
          !formData.factoryAddressSameAsCompany
            ? fieldHelper("factoryStreetDoorNo")
            : ""
        }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              size="small"
              label="Address Line 1"
              name="factoryAddressLine1"
              value={formData.factoryAddressLine1 || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
           error={
            !formData.factoryAddressSameAsCompany &&
            fieldError("factoryAddressLine1")
          }
          helperText={
            !formData.factoryAddressSameAsCompany
              ? fieldHelper("factoryAddressLine1")
              : ""
          }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Address Line 2"
              name="factoryAddressLine2"
              value={formData.factoryAddressLine2 || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
              
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Address Line 3"
              name="factoryAddressLine3"
              value={formData.factoryAddressLine3 || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Address Line 4"
              name="factoryAddressLine4"
              value={formData.factoryAddressLine4 || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Address Line 5"
              name="factoryAddressLine5"
              value={formData.factoryAddressLine5 || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Postal Code"
              name="factoryPostalCode"
              value={formData.factoryPostalCode || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
               error={
              !formData.factoryAddressSameAsCompany &&
              fieldError("factoryPostalCode")
            }
            helperText={
              !formData.factoryAddressSameAsCompany
                ? fieldHelper("factoryPostalCode")
                : ""
            }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="City"
              name="factoryCity"
              value={formData.factoryCity || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
            error={
            !formData.factoryAddressSameAsCompany &&
            fieldError("factoryCity")
          }
          helperText={
            !formData.factoryAddressSameAsCompany
              ? fieldHelper("factoryCity")
              : ""
          }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="State (Region)"
              name="factoryStateRegion"
              value={formData.factoryStateRegion || ""}
              onChange={onFieldChange}
              disabled={Boolean(formData.factoryAddressSameAsCompany)}
            error={
            !formData.factoryAddressSameAsCompany &&
            fieldError("factoryStateRegion")
          }
          helperText={
            !formData.factoryAddressSameAsCompany
              ? fieldHelper("factoryStateRegion")
              : ""
          }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Country"
              name="factoryCountry"
              value={formData.factoryCountry || ""}
              onChange={onFieldChange}
              disabled
            />
          </Grid>
        </Grid>
      </SectionCard>
      <SectionCard title="FACTORY INFORMATION">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Factory licence No"
              name="factoryLicenceNo"
              value={formData.factoryLicenceNo || ""}
              onChange={onFieldChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="No. of Plants"
              name="noOfPlants"
              value={formData.noOfPlants || ""}
              onChange={onFieldChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Total Area (Sq.ft)"
              name="totalAreaSqft"
              value={formData.totalAreaSqft || ""}
              onChange={onFieldChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}></Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Total production Capacity /Shift"
              name="totalProductionCapacityPerShift"
              value={formData.totalProductionCapacityPerShift || ""}
              onChange={onFieldChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Total production Capacity /Month"
              name="totalProductionCapacityPerMonth"
              value={formData.totalProductionCapacityPerMonth || ""}
              onChange={onFieldChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Number of Employees/Labours"
              name="numberOfEmployeesLabours"
              value={formData.numberOfEmployeesLabours || ""}
              onChange={onFieldChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Own/rental details"
              name="ownRentalDetails"
              value={formData.ownRentalDetails || ""}
              onChange={onFieldChange}
            />
          </Grid>
        </Grid>
      </SectionCard>
    </Grid>
  );
};

export default Step3FactoryInfo;
